export const useDocumentTraversalStore = (documentId: string) => {
  const { revision } = useSubmittedDocumentStore(documentId);

  if (!documentId || !revision) {
    throw new Error("Revision is not defined");
  }

  return useDocumentTraversal(documentId, revision.id)();
};
